import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en:{
        batteryTensionButton: 'Battery Tension',
        batterySocButton: 'Battery SOC',
        cellTensionButton: 'Cell Tension',
        cellTempButton: 'Cell Temperature',
        oneDay: 'One Day',
        oneWeek: 'One Week',
        oneMonth: 'One Month',
        twoMonths: 'Two Months',
        fourMonths: 'Four Months',
        sixMonths: 'Six Months',
        oneYear: 'One Year',
        loading: 'Battery data is loading, this can take a while'
    },
    fr:{
        batteryTensionButton: 'Tension batterie',
        batterySocButton: 'SOC batterie',
        cellTensionButton: 'Tension cellule',
        cellTempButton: 'Tempèrature cellule',
        oneDay: 'Un jour',
        oneWeek: 'Une semaine',
        oneMonth: 'Un mois',
        twoMonths: 'Deux mois',
        fourMonths: 'Quatre mois',
        sixMonths: 'Six mois',
        oneYear: 'Un an',
        loading: 'Les données de votre batterie sont en train de charger, cela peut prendre une minute ou deux'
    }
})

export default strings

